export default async function getMenuData(regionPayload) {
  return [
    {
      category: true,
      title: 'Dashboards',
    },
    {
      title: 'Dashboard',
      key: 'dashboard',
      icon: 'fe fe-home',
      url: '/',
    },
    {
      title: 'Pest Information',
      key: 'pest-information',
      icon: 'fe fe-info',
      children: [
        {
          title: 'Master',
          key: 'master',

          url: '/master',
        },
        {
          title: 'Country Pests',
          key: 'country-pest',

          url: '/country-pest',
        },
        {
          title: 'Distribution Map',
          key: 'distribution-map',

          url: '/distribution-map',
        },
        {
          title: 'Commodities',
          key: 'commodities',

          children: [
            {
              title: 'Commodities',
              key: 'commodities-n',
              url: '/commodities',
            },
            {
              title: 'Categories',
              key: 'commodities-categories',
              url: '/commodities/categories',
            },
            {
              title: 'Plant Parts',
              key: 'plant-parts',
              url: '/commodities/plant-parts',
            },
          ],
        },
      ],
    },

    {
      title: 'Pest Management',
      key: 'pest-management',
      icon: 'fe fe-alert-triangle',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'Pest Alert Requests',
          key: 'alert-requests',
          url: '/pest-alert/requests',
        },
        {
          title: 'Experts',
          key: 'experts',
          url: '/pest-alert/experts',
        },
        {
          title: 'Pest Notifications',
          key: 'notifications',
          url: '/pest-alert/notifications',
        },
      ],
    },
    {
      title: 'Pest Scouting',
      key: 'pest-scouting',
      icon: 'fe fe-clipboard',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'Projects',
          key: 'projects',
          url: '/pest-scouting/projects',
        },
        {
          title: 'Farms',
          key: 'farms',
          url: '/pest-scouting/farms',
        },
        {
          title: 'Scouts',
          key: 'scouts',
          url: '/pest-scouting/scouts',
        },
      ],
    },
    {
      title: 'Biopesticides',
      key: 'biopesticides',
      icon: 'fe fe-file-plus',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'Applications',
          key: 'applications',
          url: '/biopesticides/applications',
        },
        {
          title: 'Form Configuration',
          key: 'form-configuration',
          children: [
            {
              title: 'Applicant Status',
              key: 'applicant-status',
              url: '/biopesticides/applicant-status',
            },
            {
              title: 'Biopesticide Categories',
              key: 'biopesticide-category',
              url: '/biopesticides/category',
            },
            {
              title: 'WHO Hazard Classes',
              key: 'hazard-class',
              url: '/biopesticides/hazard-class',
            },
            {
              title: 'Local Agent Status',
              key: 'la-status',
              url: '/biopesticides/la-status',
            },
            {
              title: 'Product Category',
              key: 'product-category',
              url: '/biopesticides/product-category',
            },
            {
              title: 'Purpose of Application',
              key: 'purpose',
              url: '/biopesticides/purpose',
            },
            {
              title: 'Types of Use',
              key: 'type-of-use',
              url: '/biopesticides/types-of-use',
            },
          ],
        },
      ],
    },
    {
      title: 'Conventional',
      key: 'conventional',
      icon: 'fe fe-file-plus',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'Applications',
          key: 'applications',
          url: '/conventional/applications',
        },
      ],
    },
    {
      title: 'Documents',
      key: 'documents',
      icon: 'fe fe-file-text',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'Addendums',
          key: 'addendums',
          url: '/documents/addendums',
        },
        {
          title: 'SPS',
          key: 'sps',
          url: '/documents/sps',
        },
        {
          title: 'Pest Risk Analysis',
          key: 'pra',
          url: '/documents/pra',
        },
      ],
    },
    {
      title: 'Configuration',
      key: 'config',
      icon: 'fe fe-settings',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'Presence',
          key: 'presence',
          url: '/configuration/presence',
        },
        {
          title: 'Phytosanitary Status',
          key: 'phytosanitary-status',
          url: '/configuration/phytosanitary-status',
        },
        {
          title: 'Life Form',
          key: 'lifeform',
          url: '/configuration/life-form',
        },

        {
          title: 'Regions',
          key: 'regions',
          children: [
            {
              title: 'Regions',
              key: 'regions',
              url: '/configuration/regions',
            },
            {
              title: 'Countries',
              key: 'countries',
              url: '/configuration/countries',
            },
            {
              title: `${regionPayload?.plural?.adminLevelOne || ''}`,
              key: 'admin-level-one',
              url: '/configuration/admin-level-one',
            },
            {
              title: `${regionPayload?.plural?.adminLevelTwo || ''}`,
              key: 'sub-counties',
              url: '/configuration/admin-level-two',
            },
            {
              title: `${regionPayload?.plural?.adminLevelThree || ''}`,
              key: 'wards',
              url: '/configuration/admin-level-three',
            },
          ],
        },
      ],
    },
    {
      title: 'Users',
      key: 'users',
      icon: 'fe fe-users',
      // roles: ['admin'], // set user roles with access to this route
      children: [
        {
          title: 'All Users',
          key: 'all-users',
          url: '/users/all-users',
        },

        {
          title: 'Roles',
          key: 'roles',
          url: '/users/roles',
        },
        {
          title: 'Permissions',
          key: 'permissions',
          url: '/users/permissions',
        },
        {
          title: 'Permission Group',
          key: 'permission-group',
          url: '/users/permission-group',
        },
      ],
    },
    // {
    //   title: 'Reports',
    //   key: 'reports',
    //   icon: 'fe fe-file-text',
    //   // roles: ['admin'], // set user roles with access to this route
    //   children: [
    //     {
    //       title: 'Master Pest Reports',
    //       key: 'master-pest-reports',
    //       children: [
    //         {
    //           title: 'Master Pest List',
    //           key: 'master-pest-list',
    //           url: '/reports/master/list',
    //         },
    //       ],
    //     },
    //     {
    //       title: 'Country Pest Reports',
    //       key: 'country-pest-reports',
    //       children: [
    //         {
    //           title: 'Country Pest List',
    //           key: 'country-pest-list',
    //           url: '/reports/country/list',
    //         },
    //       ],
    //     },
    //   ],
    // },
  ]
}
